import Tag from 'antd/lib/tag';

/**
 * TODO: сделать по аналогии
 * https://github.com/ant-design/ant-design/blob/master/components/tag/index.tsx
 */

export default Tag;
